module.exports = __webpack_public_path__ + "static/strategy-16c38b84c8e8c271d2f366fb82566ad2.mp4";